module.exports = __webpack_public_path__ + "static/Millimetre-Regular_web-bb4c270cd7ce532a2d5f3d080e2659c3.woff";